<div class="year-review-banner" nz-row nzAlign="middle" *ngIf="!isMobile">
    <div class="banner-background" nz-row nzJustify="space-between">
        <div nz-col nzMd="20" nzXl="18" nzSm="18" nzXs="18">
            <div nz-row nzJustify="space-between">
                <div nz-col nzMd="8" nzXl="8" nzSm="8" nzXs="8">
                </div>
                <div class="title" nz-col nzMd="16" nzXl="16" nzSm="16" nzXs="16">
                    <div class="year">2023 Year In Review</div>
                    <div class="greetings">Hurray 🎉 !!! your year-in-review report for 2023 is ready</div>
                </div>
            </div>
        </div>
        <div nz-col nzMd="4" nzXl="6" nzSm="6" nzXs="6">
            <div class="check-report-btn"  (click)="showYearlyReviewModal()">
                <span>Check Report</span>
                <span class="custom-icon">
                    <app-blue-icons blueIcon="blue-caret-right"></app-blue-icons>
                </span>
            </div>
        </div>
    </div>
    <div class="image">
        <img src="../../../../assets/images/svgs/yearly-report-bn.svg" />
    </div>
</div>

<div class="year-review-banner" nz-row *ngIf="isMobile">
    <div class="banner-background" nz-row>
        <div class="title w-100p" nz-col nzMd="20" nzXl="20" nzSm="20" nzXs="20">
            <div class="year">2023 Year In Review</div>
            <div class="greetings">Hurray 🎉 !!! your year-in-review report for 2023 is ready</div>
            <div class="float-left m-t-24" (click)="showYearlyReviewModal()">
                <div class="check-report-btn">
                    <span>Check Report</span>
                    <span class="custom-icon">
                        <app-blue-icons blueIcon="blue-caret-right"></app-blue-icons>
                    </span>
                </div>
            </div>
        </div>
        <div class="image">
            <img src="../../../../assets/images/svgs/yearly-report-bn-mob.svg" />
        </div>
    </div>
